export default __webpack_public_path__ + "media/images/images_v2/hover1-6470ffa69647d2f502e44b594aad6c31.png";